export function flagRenderer(param: { value: number }) {
  const { value } = param;

  if (value === 0) {
    return '';
  }
  return `<span class='fa fa-flag flag${value}'/>`;
}
